import { CUSTOM_ELEMENTS_SCHEMA, Component, input, output } from '@angular/core';
import { BeneficioElegibilidade } from '../../../../core/models/parametros/beneficios.model';

export type BeneficioLista = Pick<BeneficioElegibilidade, 'id' | 'nome' | 'ativo'>;

const VAZIO = new Set<number>();

/**
 * Card "Benefícios do plano" das seções da aba Benefícios. Com `editavel`, também adiciona,
 * ativa/desativa e exclui; sem ele, só escolhe o benefício aberto.
 */
@Component({
  selector: 'app-beneficios-lista',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './beneficios-lista.component.html',
  styleUrl: './beneficios-lista.component.scss',
})
export class BeneficiosListaComponent {
  readonly beneficios = input.required<readonly BeneficioLista[]>();
  readonly selecionadoId = input<number | null>(null);
  readonly nomePlano = input('');
  readonly descricao = input('Escolha um benefício para ver e editar as regras dele.');
  readonly vazio = input('Nenhum benefício no plano.');
  readonly editavel = input(false);
  /** Benefícios ainda não criados (nunca salvos). */
  readonly idsNovos = input<ReadonlySet<number>>(VAZIO);
  /** Benefícios criados com edição ainda não salva. */
  readonly idsAlterados = input<ReadonlySet<number>>(VAZIO);
  /** O benefício aberto tem pendências depois de tentar salvar. */
  readonly pendente = input(false);

  readonly selecionar = output<number>();
  readonly adicionar = output<void>();
  readonly ativar = output<{ id: number; ativo: boolean }>();
  readonly excluir = output<number>();
}
